<template lang="html">
  <form role="form" @submit.prevent.stop>
    <payout-form-group-section-checkbox class="my-little-paddington" v-model="internal" @input="onInternalClick" :label="$t('Перевод между своими счетами')"></payout-form-group-section-checkbox>
    <payout-form-group :label="$t('Получатель')" :required="true" :has-errors="model.errors.has('destinationAccount')">
      <div class="fix-wrapper">
        <template v-if="internal">
          <PrimeDropdownAccounts v-model="model.values.destinationAccount" :include-cards-pro="true" :accounts="destAccounts" :required="true"></PrimeDropdownAccounts>
        </template>
        <template v-else="v-else">
          <input class="form-control" type="text" v-model="model.values.destinationAccount" :placeholder="$t('Введите номер счета')" :required="true"/>
        </template>
      </div>
      <payout-input-hint-block v-slot:hints :hint="$t('Номер счета получателя')"></payout-input-hint-block>
      <error-message-block v-slot:errors :attribute="'destinationAccount'" :errors="model.errors"></error-message-block>
    </payout-form-group>
    <payout-form-group v-show="model.values.destinationAccount">
      <capitalist-internal-payment-beneficiary-details :beneficiary="model.values.destinationAccount"></capitalist-internal-payment-beneficiary-details>
    </payout-form-group>
    <payout-textfield-input-group :model="model" :label="$t('Назначение')" :required="true" attribute="description"></payout-textfield-input-group>
    <payout-input-amount-form-group :model="model"></payout-input-amount-form-group>
    <payout-evaluate-fee-form-group :model="model"></payout-evaluate-fee-form-group>
    <CurrencyExchangeWillBeAppliedNoticeGroup :model="model"></CurrencyExchangeWillBeAppliedNoticeGroup>
    <hr/>
    <payout-group-verification-type :model="model"></payout-group-verification-type>
  </form>
</template>

<script lang="ts">
import {computed, defineComponent, reactive, ref, watch} from "vue";
import AbstractPayoutForm from "@/components/forms/payout/abstract/AbstractPayoutForm.vue";
import {
  CapitalistInternalPaymentModel
} from "@/components/forms/payout/forms/capitalist/capitalist-internal";
import {Account} from "@/models/finance/account";
import PayoutFormGroupSectionCheckbox
  from "@/components/forms/payout/formgroup/PayoutFormGroupSectionCheckbox.vue";
import PayoutFormGroup from "@/components/forms/payout/PayoutFormGroup.vue";
import PayoutTextfieldInputGroup from "@/components/forms/payout/PayoutTextfieldInputGroup.vue";
import PayoutInputAmountFormGroup from "@/components/forms/payout/PayoutInputAmountFormGroup.vue";
import PayoutEvaluateFeeFormGroup from "@/components/forms/payout/PayoutEvaluateFeeFormGroup.vue";
import CapitalistInternalPaymentBeneficiaryDetails
  from "@/components/forms/payout/forms/capitalist/CapitalistInternalPaymentBeneficiaryDetails.vue";
import PayoutGroupVerificationType
  from "@/components/payout/verification/PayoutGroupVerificationType.vue";
import ErrorMessageBlock from "@/components/forms/payout/ErrorMessageBlock.vue";
import PayoutInputHintBlock from "@/components/forms/payout/PayoutInputHintBlock.vue";
import CurrencyExchangeWillBeAppliedNoticeGroup
  from "@/components/forms/payout/forms/capitalist/CurrencyExchangeWillBeAppliedNoticeGroup.vue";
import PrimeDropdownAccounts from "@/components/forms/dropdown/PrimeDropdownAccounts.vue";

const model = reactive(new CapitalistInternalPaymentModel);
const internal = ref(false);

const destAccounts = computed(() => {
  const accounts = model.options.destaccounts || model.options.accounts || [];
  return model.loaded ? accounts.map((accountData) => {
    return Account.createFromData(accountData);
  }) : [];
});

const onInternalClick = (value) => {
  // console.log('internal click:', value);
  if (value) {
    const idx = destAccounts.value.findIndex((account) => {
      return account.number === model.values.destinationAccount;
    });
    if (idx === -1) {
      model.values.destinationAccount = '';
    }
  }
}

watch(() => model.values.destinationAccount, (value) => {
  const idx = destAccounts.value.findIndex((account) => {
    return account.number === model.values.destinationAccount;
  });
  // console.log('watch value:', model.values.destinationAccount, idx, internal.value);
  if (!internal.value && idx !== -1) {
    internal.value = true;
    // console.log('watch internal:', internal.value);
  }
}, {
  flush: 'post',
});

export default defineComponent({
  name: "CapitalistInternalPaymentForm",
  components: {
    PrimeDropdownAccounts,
    CurrencyExchangeWillBeAppliedNoticeGroup,
    PayoutInputHintBlock, ErrorMessageBlock,
    PayoutGroupVerificationType,
    CapitalistInternalPaymentBeneficiaryDetails,
    PayoutEvaluateFeeFormGroup,
    PayoutInputAmountFormGroup,
    PayoutTextfieldInputGroup,
    PayoutFormGroup, PayoutFormGroupSectionCheckbox},
  extends: AbstractPayoutForm,
  setup() {
    return {
      model,
      internal,
      destAccounts,
      onInternalClick
    };
  },
})
</script>

<style scoped lang="less">
.fix-wrapper {
  width: 370px;
}
.my-little-paddington {
  padding-bottom: 10px;
}
</style>

<i18n>
  {
    "ru": {
    },
    "en": {
      "Перевод между своими счетами": "Transfer between your accounts",
      "Получатель": "Recipient",
      "Введите номер счета": "Enter account number",
      "Назначение": "Description",
      "Номер счета получателя": "Recipient account number"
    }
  }
</i18n>
